import { PillsInputProps } from '@mantine/core';
import { TreeSelectItemType } from '@vision/ui/interfaces';
import { DefaultToggleSelectProps, TreeSelectContextProvider } from './TreeSelectContext';
import { RenderTreeSelectItemProps, TreeSelectItemRenderer } from './components';

interface TreeSelectProps<T> {
  inputProps?: Omit<PillsInputProps, 'data-testid'> & {
    placeholder?: string;
  };
  items: T[];
  mapper: (item: T) => TreeSelectItemType;
  onChange: (value: string[]) => void;
  value: string[];
  withDropdown?: boolean;
  withSubCategories?: boolean;
  showSelectedItemsOnTop?: boolean;
  loading?: boolean;
  renderTreeSelectItem?: (props: RenderTreeSelectItemProps) => React.ReactNode;
  openLevel?: number;
  toggleSelect?: (props: DefaultToggleSelectProps) => void;
  isLoaded?: (items: TreeSelectItemType[]) => void;
  selectedDefaultOpen?: boolean;
  portal?: boolean;
  openedControlled?: boolean;
  withSelectAll?: boolean;
}

export function TreeSelect<T>({
  inputProps,
  items,
  mapper,
  onChange,
  value,
  withDropdown,
  withSubCategories = true,
  showSelectedItemsOnTop = true,
  renderTreeSelectItem,
  openLevel,
  toggleSelect,
  isLoaded,
  selectedDefaultOpen = true,
  portal = true,
  openedControlled,
  withSelectAll = true,
}: TreeSelectProps<T>) {
  return (
    <TreeSelectContextProvider
      items={items}
      mapper={mapper}
      onChange={onChange}
      value={value}
      withSubCategories={withSubCategories}
      toggleSelect={toggleSelect}
      isLoaded={isLoaded}
      selectedDefaultOpen={selectedDefaultOpen}
    >
      <TreeSelectItemRenderer
        withDropdown={withDropdown}
        inputProps={inputProps}
        showSelectedItemsOnTop={showSelectedItemsOnTop}
        renderTreeSelectItem={renderTreeSelectItem}
        openLevel={openLevel}
        portal={portal}
        openedControlled={openedControlled}
        withSelectAll={withSelectAll}
      />
    </TreeSelectContextProvider>
  );
}
